module.exports = __webpack_public_path__ + "static/media/20110524_4537.112608be.jpg";